module.exports = __webpack_public_path__ + "static/Karan_Prasad-664f2bb67057e6b74d06664c069529ff.jpeg";